import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDashboard, faSignOut } from "@fortawesome/free-solid-svg-icons";

import { useAuthentication } from "../../../services/authentication/authentication.context";
import { SiteHeader } from "../../components/header/header";
import { LoadingIndicator } from "../../components/utils/loader";
import { AppAlert } from "../../components/utils/alert";
import { faEdit, faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { formatImageUrl } from "../../_helpers/route-image";


export const AdminPage = () => {

    const { account, token, logoutUser, deleteUser, isLoading } = useAuthentication();

    const navigateTo = useNavigate();

    const [onAlert, setOnAlert] = useState();

    const handlePromptLogout = () => {
        setOnAlert({
            caption: "Déconnexion",
            message: "Souhaitez-vous vous déconnecter ?",
            accept: "Se déconnecter",
            reject: "Annuler",
            onAccept: async () => {
                setOnAlert();
                handleLogout();
            },
            onReject: () => setOnAlert()
        })
    }

    const handleClosePrompt = () => {
        setOnAlert({
            caption: "Suprimer le compte",
            message: "Souhaitez-vous supprimer votre compte ? Cette action est irréversible !",
            accept: "Suprimer",
            reject: "Annuler",
            onAccept: async () => {
                setOnAlert();
                handleCloseAcount();
            },
            onReject: () => setOnAlert()
        })
    }

    const handleCloseAcount = async () => {
        const resp = await deleteUser(token);
        if (resp?.error) {
            setOnAlert({
                caption: "Erreur",
                message: resp?.error,
                accept: "Ok",
                onAccept: () => setOnAlert(),
            });
            return;
        }
        localStorage.removeItem('accessToken');

        setOnAlert({
            caption: "Compte suprimé",
            message: "Ce fut un plaisir. Nous espérons vous revoir bientôt.",
            accept: "Ok",
            onAccept: () => setOnAlert(),
        })
        window.location.reload();
    }

    const handleLogout = async () => {
        const resp = await logoutUser(token);
        if (resp?.error) {
            setOnAlert({
                caption: "Erreur",
                message: resp?.error,
                accept: "Ok",
                onAccept: () => setOnAlert(),
            });
            return;
        }
        localStorage.removeItem('accessToken');
        window.location.reload();
    }

    return (
        <div className="page-body">
            <SiteHeader pageTitle={'Admin'} />
            {isLoading && <LoadingIndicator />}
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    reject={onAlert.reject}
                    onAcept={onAlert.onAccept}
                    onReject={onAlert.onReject}
                    onClose={() => setOnAlert()}
                />
            )}
            <div className="account-details">
                <div className="avatar-box">
                    <img
                        src={account?.avatar ? formatImageUrl(account?.avatar) : "/svgs/user-avatar.svg"}
                        alt="" className="avatar"
                    />
                </div>
                <div className="detail-unit">
                    <span className="detail-caption">Noms</span>
                    <span className="detail-data">{account?.names}</span>
                </div>
                <div className="detail-unit">
                    <span className="detail-caption">Email</span>
                    <span className="detail-data">{account?.email}</span>
                </div>
                <div className="admin-actions">
                    <button 
                        className="admin-action-button" 
                        onClick={() => window.location.href = "/fr/updateaccount"}
                    >
                        <FontAwesomeIcon icon={faEdit} className="button-icon" />
                        <span>Mettre à jour le compte</span>
                    </button>
                    <button
                        className="admin-action-button"
                        onClick={() => handlePromptLogout()}
                    >
                        <FontAwesomeIcon icon={faSignOut} className="button-icon" />
                        <span>Déconnecter</span>
                    </button>
                    <button
                        className="admin-action-button"
                        onClick={() => handleClosePrompt()}
                    >
                        <FontAwesomeIcon icon={faTrashAlt} className="button-icon" />
                        <span>Suprimer mon compte</span>
                    </button>
                    {account?.role === "admin" && (
                        <button
                            className="admin-action-button"
                            onClick={() => navigateTo("/fr/dashboard")}
                        >
                            <FontAwesomeIcon icon={faDashboard} className="button-icon" />
                           <span>Tableau de bord</span> 
                        </button>
                    )}
                </div>
            </div>
        </div>
    )
}